<template>
    <div class="flex flex-wrap justify-start mb-2 gap-2">
        <div v-for="(subscription, index) in data"
            class="p-4 bg-white rounded-md border border-gray-300 w-full transition relative">
            <div @click="removeSubscription(index)"
                class="w-5 h-5 absolute text-xs -right-2 -top-2 rounded-full bg-gray-100 text-gray-700 border border-gray-300 flex items-center justify-center hover:scale-90 transition cursor-pointer hover:bg-gray-300">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" fill=currentColor
                    viewBox="0 0 384 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
                    <path
                        d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
                </svg>
            </div>
            <div class="w-full p-2 flex items-end gap-2">
                <input type="hidden" :id="'webhooks['+index+'][id]'"  :name="'webhooks['+index+'][id]'" :value="subscription.id ?? null">
                <div class="flex items-center">
                    <input id="active" type="checkbox" v-model="subscription.active" :name="'webhooks['+index+'][active]'"
                        class="w-[42px] h-[42px] text-primary bg-gray-100 border-gray-300 rounded-lg focus:ring-primary dark:focus:ring-primary dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                </div>
                <div class="min-w-fit">
                    <label for="type" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {{ $t("Type")}}</label>
                    <select id="type" v-model="subscription.type" :name="'webhooks['+index+'][type]'"
                        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary focus:border-primary block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary dark:focus:border-primary">
                        <option disabled value="">{{$t("Choose a type")}}</option>
                        <option value="BookingEvents">{{ $t("Booking Events") }}</option>
                    </select>
                </div>
                <div class="w-full">
                    <label for="url" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">{{$t('URL')}}</label>
                    <input type="text" id="url" v-model="subscription.url" :name="'webhooks['+index+'][url]'"
                        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary focus:border-primary block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary dark:focus:border-primary"
                        placeholder="https://..." required />
                </div>
                <div class="w-full">
                    <label for="signature" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">{{ $t("Signature") }}</label>
                    <input type="text" id="signature" v-model="subscription.signature" :name="'webhooks['+index+'][signature]'"
                        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary focus:border-primary block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary dark:focus:border-primary"
                        placeholder="secret signature" required />
                </div>

                <div class="w-full">
                    <label for="custom_headers" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">{{ $t("Custom headers") }}</label>
                    <input type="text" id="custom_headers" v-model="subscription.custom_headers" :name="'webhooks['+index+'][custom_headers]'"
                        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary focus:border-primary block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary dark:focus:border-primary"
                        placeholder="" />
                </div>
            </div>
        </div>

        <div @click="addSubscription"
            class="p-4 bg-white rounded-md border border-gray-300 w-full flex justify-center items-center hover:scale-95 active:scale-90 hover:bg-gray-200 transition cursor-pointer">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 mr-2" fill=currentColor
                viewBox="0 0 448 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
                <path
                    d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z" />
            </svg>
            {{ $t('Add') }} {{ $t("webhook subscription") }}
        </div>
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            default: { 'type': '', 'active': false, 'url': '', 'signature': '' },
            data: JSON.parse(this.$attrs.data),
        };
    },
    methods: {
        addSubscription(e) {
            this.data.push(_.cloneDeep(this.default));
        },
        removeSubscription(index) {
            var item = _.cloneDeep(this.data);
            item.splice(index, 1);
            this.data = [];

            var _this = this;
            setTimeout(function () {
                _this.data = item;
            }, 1)
        },
    }
};
</script>